/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Health professional in an Institute
 * @export
 * @interface HealthProLight
 */
export interface HealthProLight {
    /**
     * 
     * @type {string}
     * @memberof HealthProLight
     */
    personWithRoleId: string;
    /**
     * 
     * @type {string}
     * @memberof HealthProLight
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof HealthProLight
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof HealthProLight
     */
    lastName: string;
}

/**
 * Check if a given object implements the HealthProLight interface.
 */
export function instanceOfHealthProLight(value: object): value is HealthProLight {
    if (!('personWithRoleId' in value) || value['personWithRoleId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function HealthProLightFromJSON(json: any): HealthProLight {
    return HealthProLightFromJSONTyped(json, false);
}

export function HealthProLightFromJSONTyped(json: any, ignoreDiscriminator: boolean): HealthProLight {
    if (json == null) {
        return json;
    }
    return {
        
        'personWithRoleId': json['personWithRoleId'],
        'title': json['title'] == null ? undefined : json['title'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
    };
}

export function HealthProLightToJSON(json: any): HealthProLight {
    return HealthProLightToJSONTyped(json, false);
}

export function HealthProLightToJSONTyped(value?: HealthProLight | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'personWithRoleId': value['personWithRoleId'],
        'title': value['title'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
    };
}

